<template>
  <div v-if="loading" class="ui-block" data-cy="ui-block">
    <ProgressSpinner
      style="width: 50px; height: 50px"
      strokeWidth="8"
      fill="transparent"
      animationDuration=".7s"
      aria-label="Loading"
      class="spinner"
    />
    <p class="loading-text" data-cy="loading-text">{{ loadingMessage }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ProgressSpinner from "primevue/progressspinner";

const props = defineProps<{
  loading: boolean;
  loadingMessage?: string;
}>();

const loadingMessage = computed(() => props.loadingMessage ?? "Loading");
</script>

<style lang="scss" scoped>
.ui-block {
  background-color: $maskBg;
  min-height: 100vh;
  min-width: 100vw;
  position: fixed;
  top: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .spinner {
    margin-bottom: 1rem;
  }

  .loading-text {
    font-size: 1.5em;
    color: $primaryTextColor;
  }
}
</style>
